import { ComplexStyleRule, GlobalStyleRule } from '@vanilla-extract/css'

export const cssClass = (className: string[]) => className.join(' ')

export const conditionalClass = (
  condition: boolean,
  className: string | string[],
  alternativeClassName: string | string[] = ''
) => {
  if (condition) {
    return Array.isArray(className) ? cssClass(className) : className
  }

  return Array.isArray(alternativeClassName)
    ? cssClass(alternativeClassName)
    : alternativeClassName
}

// mediaquerys
export const responsiveStyle = ({ tablet, desktop, desktopXl }) => ({
  '@media': {
    'screen and (min-width: 768px)': tablet,
    'screen and (min-width: 1024px)': desktop,
    'screen and (min-width: 1280px)': desktopXl,
  },
})
// tramsform px to rem
export const rem = (px: number) => `${px / 16}rem`

export const queries = {
  tablet: 768,
  desktop: 1024,
  desktopXl: 1280,
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const media: any = (media: number, style: ComplexStyleRule) => ({
  [`screen and (min-width: ${media}px)`]: style,
})

export const mediaTablet = (style: ComplexStyleRule) => {
  return media(queries.tablet, style)
}

export const mediaDesktop = (style: ComplexStyleRule) => {
  return media(queries.desktop, style)
}

export const mediaDesktopXl = (style: ComplexStyleRule) => {
  return media(queries.desktopXl, style)
}

export const queriesKeys = Object.keys(queries)

interface IGenerateGlobalStyles {
  variants: object
  prefix: string
  cssProperty: string | string[]
  config?: {
    media?: boolean
    hoover?: boolean
  }
  generationFucntion: (selector: string, rule: GlobalStyleRule) => void
  formater?: (variant: string | number) => string | number
}

export const generateObjectFromArray = (array: string[]) => {
  const object = {}
  array.forEach((item) => {
    object[item] = item
  })
  return object
}

export const generateGlobalStyles = ({
  variants,
  prefix,
  cssProperty,
  config = {},
  generationFucntion,
  formater = (variant) => variant,
}: IGenerateGlobalStyles) => {
  const keys = Object.keys(variants)

  keys.forEach((variant) => {
    let style

    if (typeof cssProperty === 'string') {
      style = {
        [cssProperty]: formater(variants[variant]),
      }
    } else {
      style = {}
      cssProperty.forEach((property) => {
        style[property] = formater(variants[variant])
      })
    }

    generationFucntion(`.--v2 .${prefix}${variant}`, style)

    if (config?.media) {
      queriesKeys.forEach((query) => {
        generationFucntion(`.--v2 .${prefix}${variant}--${query}`, {
          '@media': {
            [`screen and (min-width: ${queries[query]}px)`]: style,
          },
        })
        if (config?.hoover) {
          generationFucntion(
            `.--v2 .hover__${prefix}${variant}--${query}:hover`,
            {
              '@media': {
                [`screen and (min-width: ${queries[query]}px)`]: style,
              },
            }
          )
        }
      })
    }

    if (config?.hoover) {
      generationFucntion(`.--v2 .hover__${prefix}${variant}:hover`, style)
    }
  })
}
